
import { Component, Vue, Prop } from 'vue-property-decorator'
import ProjectExplore from "@/components/explore/ProjectExplore.vue"
import HdsTab from '@/components/explore/hds/HdsTab.vue'
import ImageSlider from '@/components/explore/ImageSlider.vue'
import ReadMoreBtn from '@/components/explore/hds/ReadMoreBtn.vue'
import { IPublicShowcasePage } from '@/types/showcase'
import ProjectCard from '@/components/explore/ProjectCard.vue'
import ShowcaseLinks from '@/components/showcase_generator/templates/common/ShowcaseLinks.vue'
import ShowcaseProjectExplore from '../ShowcaseProjectExplore.vue'
import ShowcaseDocuments from './common/ShowcaseDocuments.vue'
import ContactPerson from '@/components/explore/ContactPerson.vue'
import SocialMedia from '../social_media/SocialMedia.vue'
import TabContainer from '@/components/detail_pages/TabContainer.vue'
import { ITab } from '@/types/detailPages'
import { IExploreProjectDetail, ILocation } from '@/types/projects'
import ShowcaseProjectCard from '../ShowcaseProjectCard.vue'
import GenericCard from '@/components/detail_pages/GenericCard.vue'

@Component({
  components: {
    ProjectExplore,
    HdsTab,
    ImageSlider,
    ReadMoreBtn,
    ProjectCard,
    ShowcaseProjectExplore,
    ShowcaseLinks,
    ShowcaseDocuments,
    ContactPerson,
    SocialMedia,
    TabContainer,
    ShowcaseProjectCard,
    GenericCard
  }
})
export default class PromotionRecommendation extends Vue {
  @Prop({ required: true }) showcasePage: IPublicShowcasePage

  projectLocations: ILocation[] = []

  affiliateParam = ""

  tabs: ITab[] = [
    {
      key: "promotion_recommendation",
      title: this.$gettext("What we have achieved"),
      is_active: true,
      tab_settings: {
        show_images: true,
        show_title_above_images: false
      },
      tab_content: {
        title: "",
        text: "",
        photos: [],
        links: [],
        documents: [],
        contact_person: null,
        contact_person_logo: "",
        contact_person_title: ""
      },
      navbar_settings: {
        title: "",
        logo_url: "",
        show_tabs: false
      }
    }
  ]

  tabsSet = false

  get mainColor (): string {
    return this.showcasePage.colors.primary || this.showcasePage.colors.organization
  }

  async mounted (): Promise<void> {
    this.affiliateParam = this.showcasePage.slug
    await this.setTabs()
    if (this.showcasePage.show_map) {
      await this.setProjectLocations()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getGenericCardProps(project: any) {
    if (this.showcasePage.show_result_reports) {
      return this.getGenericCardPropsForResultReport(project)
    } else {
      return this.getGenericCardPropsForProject(project)
    }
  }

  getGenericCardPropsForResultReport(project: IExploreProjectDetail) {
    return {
      title: project.result_report.title,
      subTitle: {
        firstLine: `${project.organization.title}`,
        secondLine: ""
      },
      imageSrc: project.result_report.photos.length ? project.result_report.photos[0].src : '/static/img/default/project-placeholder-new.png',
      customBtnStyle: this.useShowcasePageColor,
      viewBtnText: this.$gettext('View result report')
    }
  }

  getGenericCardPropsForProject(project: IExploreProjectDetail) {
    return {
      title: project.title,
      subTitle: {
        firstLine: `${project.organization.title}`,
        secondLine: `${project.city}, ${project.country} | ${project.category}`
      },
      imageSrc: project.photos.length ? project.photos[0].src : '/static/img/default/project-placeholder-new.png',
      customBtnStyle: this.useShowcasePageColor,
      viewBtnText: this.$gettext('View Project')
    }
  }

  get useShowcasePageColor () {
    const color = this.mainColor
    return {
      'background-color': color,
      border: color
    }
  }

  getTabByKey (key: string): ITab {
    return this.tabs.find(tab => tab.key === key) as ITab
  }

  async setTabs (): Promise<void> {
    const tab = this.getTabByKey('promotion_recommendation')
    tab.tab_content.title = this.showcasePage.title
    tab.tab_content.text = this.showcasePage.text
    tab.tab_content.photos = this.showcasePage.photos
    tab.tab_content.links = this.showcasePage.links
    tab.tab_content.documents = this.showcasePage.documents
    tab.tab_content.contact_person = this.showcasePage.contact_persons.length > 0 ? this.showcasePage.contact_persons[0] : null
    tab.tab_content.contact_person_logo = this.showcasePage.logo.length > 0 ? this.showcasePage.logo[0].src : ''
    tab.navbar_settings.logo_url = this.showcasePage.logo.length > 0 ? this.showcasePage.logo[0].src : ''
    tab.tab_content.contact_person_title = this.showcasePage.contact_person_title
    tab.navbar_settings.title = this.showcasePage.page_heading || this.$gettext("Promotion recommendation")

    this.tabsSet = true
  }

  async setProjectLocations (): Promise<void> {
    this.projectLocations = this.showcasePage.projects.map(project => {
      return {
        longitude: project.longitude,
        latitude: project.latitude,
        project_title: project.title,
        project_slug: project.slug,
        marker_icon: null
      }
    })
  }

  get showcaseLogo (): string {
    return this.showcasePage.logo.length > 0 ? this.showcasePage.logo[0].src : ''
  }

  get openLinkInNewTab (): boolean {
    /* eslint-disable object-shorthand */
    return this.$route.query?.widget === 'true' || this.$route.path.endsWith('/widget/')
  }

  openProject (projectSlug: string): void {
    const params = { projectSlug: projectSlug }
    const query = { showcase: this.affiliateParam }
    const projectRoute = { name: 'project-detail', params: params, query: query }
    if (this.showcasePage.show_result_reports) {
      const url = "/project/" + projectSlug + "/public-result-report/"
      if (this.openLinkInNewTab) {
        window.open(url, '_blank')
      } else {
        window.open(url, '_self')
      }
    } else {
      if (this.openLinkInNewTab) {
        window.open(this.$router.resolve(projectRoute).href, '_blank')
        return
      }
      this.$router.push(projectRoute)
    }
  }
}
